(function() {
    function initPricingGridScripts(context = document) {
        const cards = context.querySelectorAll('.pricing-grid .card');
        const quantityInputs = context.querySelectorAll('input[name="quantity"]');
        const plusQty = context.querySelectorAll('button[name="plus"]');
        const minusQty = context.querySelectorAll('button[name="minus"]');

        if (!cards.length) return;

        function setActiveCardByQuantity(qty) {
            let targetQty = 1;

            /*if (qty >= 200) targetQty = 200;
            else if (qty >= 100) targetQty = 100;
            else if (qty >= 50) targetQty = 50;
            else if (qty >= 20) targetQty = 20;
            else*/ if (qty >= 10) targetQty = 10;
            else if (qty >= 5) targetQty = 5;
            else if (qty >= 2) targetQty = 2;

            quantityInputs.forEach(Ele => Ele.value = qty);

            cards.forEach(function(card) {
                const cardQty = parseInt(card.getAttribute('data-qty'));

                if (cardQty === targetQty) {
                    card.classList.add('active');

                    const perPack = card.querySelector('.per-pack');
                    const discountedPrice = perPack.getAttribute('parPackPrice');
                    const regPrice = perPack.getAttribute('regPrice');
                    const discountPer = perPack.getAttribute('discount');

                    const comparePrice = (parseFloat(regPrice) * qty).toFixed(2);
                    const regularPrice = (parseFloat(discountedPrice) * qty).toFixed(2);

                    // Update regular price
                    context.querySelectorAll('.selectedPrice .regularPrice')
                        .forEach(ele => ele.textContent = '$' + regularPrice );

                    // Update compare price
                    const comPricetext = context.querySelectorAll('.selectedPrice .comparePrice');
                    const saveText = context.querySelectorAll('.selectedPrice .youSave');

                    if (discountPer !== '0') {
                        comPricetext.forEach(ele => ele.textContent = '$' + comparePrice );

                        const saveAmount = (comparePrice - regularPrice).toFixed(2);
                        
                        saveText.forEach(ele => {
                            ele.innerHTML = '<span>You save $' + saveAmount + ' </span>';
                        });

                    } else {
                        comPricetext.forEach(ele => ele.textContent = '');
                        saveText.forEach(ele => ele.textContent = '');
                    }

                } else {
                    card.classList.remove('active');
                }
            });
        }

        // Click event
        cards.forEach(function(card) {
            card.addEventListener('click', function() {
                const qty = parseInt(this.getAttribute('data-qty'));
                quantityInputs.forEach(input => {
                    input.value = qty;
                    input.dispatchEvent(new Event('input'));
                });
            });
        });

        // Input change
        quantityInputs.forEach(input => {
            input.addEventListener('input', function() {
                const inputQty = parseInt(this.value);
                if (!isNaN(inputQty)) setActiveCardByQuantity(inputQty);
            });
        });

        // Plus
        plusQty.forEach(btn => {
            btn.addEventListener('click', function() {
                setTimeout(() => {
                    const input = this.closest('quantity-input')?.querySelector('input[name="quantity"]');
                    const inputQty = parseInt(input?.value);
                    if (!isNaN(inputQty)) setActiveCardByQuantity(inputQty);
                }, 50);
            });
        });

        // Minus
        minusQty.forEach(btn => {
            btn.addEventListener('click', function() {
                setTimeout(() => {
                    const input = this.closest('quantity-input')?.querySelector('input[name="quantity"]');
                    const inputQty = parseInt(input?.value);
                    if (!isNaN(inputQty)) setActiveCardByQuantity(inputQty);
                }, 50);
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        initPricingGridScripts();
    });

    const quickModals = document.querySelectorAll('.quick-add-modal');
    quickModals.forEach(modal => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.attributeName === 'open' && modal.hasAttribute('open')) {
                    initPricingGridScripts(modal);
                }
            });
        });
        observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
    });
})();
